(() => {
const $812eeeb0ccc0df05$var$mesh = ()=>{
    const calculateMeshSize = ()=>{
        if (window.innerWidth > 2000) return [
            30,
            100,
            1000
        ];
        else if (window.innerWidth > 1000) return [
            15,
            60,
            300
        ];
        return [
            10,
            100,
            500
        ];
    };
    let [meshSize, A, sigma] = calculateMeshSize();
    const canvas = document.getElementById('background');
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    const ctx = canvas.getContext('2d', {
        willReadFrequently: true
    });
    let width = canvas.clientWidth;
    let height = canvas.clientHeight;
    let horizont = [
        Math.ceil(width / 2),
        -1 * height
    ];
    let mouseposition = [
        Math.ceil(width / 2),
        Math.ceil(height / 2)
    ];
    let dorender = true;
    const render = ()=>{
        if (!dorender) return;
        dorender = false;
        ctx.clearRect(0, 0, width, height);
        ctx.strokeStyle = '#a89984';
        ctx.fillStyle = '#a89984';
        let ylines = Math.ceil(height / meshSize);
        let xlines = Math.ceil(width / meshSize);
        for(let i = 0; i <= ylines; ++i){
            const y = meshSize * i;
            for(let j = 0; j <= xlines; ++j){
                const x = meshSize * j;
                const dx = x - mouseposition[0];
                const dy = y - mouseposition[1];
                let r = Math.sqrt(dx ** 2 + dy ** 2);
                const f = A * Math.exp((-1 * r) ** 2 / (2 * sigma ** 2));
                let newx, newy;
                if (r === 0) {
                    newx = x;
                    newy = y;
                } else {
                    newx = x + f * dx / r;
                    newy = y + f * dy / r;
                }
                ctx.beginPath();
                ctx.rect(newx, newy, 2, 2);
                ctx.fill();
            }
        }
    };
    const frame = ()=>{
        render();
        requestAnimationFrame(frame);
    };
    requestAnimationFrame(frame);
    window.addEventListener('resize', ()=>{
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
        width = canvas.clientWidth;
        height = canvas.clientHeight;
        horizont = [
            Math.ceil(width / 2),
            -1 * height
        ];
        [meshSize, A, sigma] = calculateMeshSize();
        dorender = true;
    });
    canvas.parentNode.addEventListener('mousemove', (event)=>{
        mouseposition = [
            event.pageX,
            event.pageY
        ];
        dorender = true;
    });
    let targetPosition = [
        50,
        50
    ];
    const intervalAnimation = setInterval(()=>{
        if (window.innerWidth > 500) return;
        mouseposition[0] += (targetPosition[0] - mouseposition[0]) * 0.006;
        mouseposition[1] += (targetPosition[1] - mouseposition[1]) * 0.006;
        if (Math.abs(mouseposition[0] - targetPosition[0]) <= 50 && Math.abs(mouseposition[1] === targetPosition[1]) <= 50) {
            targetPosition[0] = Math.random() * (canvas.width - 50) + 50;
            targetPosition[1] = Math.random() * (canvas.height - 50) + 50;
        }
        dorender = true;
    }, 10);
};
(()=>{
    $812eeeb0ccc0df05$var$mesh();
    (()=>{
        const mailto = document.querySelector('a.contact-click');
        mailto.addEventListener('click', (e)=>{
            gtag('event', 'mailto');
        });
    })();
})();

})();
//# sourceMappingURL=app.js.map
